import { render, staticRenderFns } from "./AllPayments.vue?vue&type=template&id=1101504c&"
import script from "./AllPayments.vue?vue&type=script&lang=ts&"
export * from "./AllPayments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports